import { freeze } from '@rehaje/shared'

import type {
  SchemaNullSpecific,
  SchemaUndefinedSpecific,
  SchemaUnknownSpecific,
  SchemaVoidSpecific
} from './types'

export const DevMode = typeof __DEV__ === 'boolean' && __DEV__

export const DefaultIndexes = freeze([0])

export const DefaultExposedKeys = freeze(['type', 'id'])

export const UnknownSchema = freeze<SchemaUnknownSpecific>({
  type: 'Schema.Unknown'
})

export const UndefinedSchema = freeze<SchemaUndefinedSpecific>({
  type: 'Schema.Undefined',
  value: undefined
})

export const NullSchema = freeze<SchemaNullSpecific>({
  type: 'Schema.Null',
  value: null
})

export const VoidSchema = freeze<SchemaVoidSpecific>({
  type: 'Schema.Void'
})

export const RequiredUnknownSchema = freeze<SchemaUnknownSpecific>({
  required: true,
  type: 'Schema.Unknown'
})

export const RequiredUndefinedSchema = freeze<SchemaUndefinedSpecific>({
  required: true,
  type: 'Schema.Undefined',
  value: undefined
})

export const RequiredNullSchema = freeze<SchemaNullSpecific>({
  required: true,
  type: 'Schema.Null',
  value: null
})

export const RequiredVoidSchema = freeze<SchemaVoidSpecific>({
  required: true,
  type: 'Schema.Void'
})
